import { ComponentType } from 'react';
import { Typography } from '@mui/material';
import { RegionsEditForm, RegionsEditFormProps } from '../regions-edit-form';
import { useTranslation } from 'react-i18next';
import { BaseDialog } from '../../dialogs';

interface RegionsEditDialogProps extends RegionsEditFormProps {
  title?: string;
  popDialog?: any;
}

export const RegionsEditDialog: ComponentType<RegionsEditDialogProps> = ({
  title: dialogTitle,
  id,
  popDialog,
  onSubmit,
  ...props
}) => {
  const { t } = useTranslation();
  const title = dialogTitle ? dialogTitle : t('regions.add', 'Добавить регион');

  return (
    <BaseDialog {...{ ...props, popDialog }}>
      {title && (
        <Typography variant="h2" component="h6" mb={2}>
          {title}
        </Typography>
      )}
      <RegionsEditForm id={id} onSubmit={onSubmit} onCancel={popDialog} />
    </BaseDialog>
  );
};
